import React, { Fragment, useState, useEffect } from 'react'
import MainLayout from '../layouts/MainLayout';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { TablePagination, TableBody, TableCell, TableRow, TableHead, Table, TableContainer } from '@mui/material';
import moment from 'moment';
import SkeletonTable from '../components/Skeleton/SkeletonTable';
import { useNavigate } from 'react-router-dom';

const TinTucPage = ({ tintucStore }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    useEffect(() => {
        tintucStore.clearNewsList();
        (async () => {
            setLoading(true);
            try {
                await Promise.all([tintucStore.getAllNews()]);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [page || rowsPerPage])
    let newsList = toJS(tintucStore.newsList)
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        tintucStore.setTintucQueryParams({ page: newPage, size: rowsPerPage });
    };


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        tintucStore.setTintucQueryParams({ page: page, size: parseInt(event.target.value, 10) });
    };

    return (
        <MainLayout initialValue={4}>
            <div className='px-5'>
                <div className="items-center mb-[16px]">
                    <div className="font-bold text-[28px] leading-[29px]  ">
                        Thông báo chung
                    </div>
                </div>
                {loading ? (<SkeletonTable />) : <div className='custom-table'>
                    <section className="mt-5 overflow-x-auto hideScrollbar work-table">
                        <TableContainer
                            className="inline-block w-auto overflow-visible hideScrollbar shadow-none border-[1px] border-[rgba(224,224,224,1)] rounded-lg"
                        >
                            <Table
                                sx={{ width: 777 }}
                                aria-label="simple table"
                            >
                                <TableHead className="bg-primary">
                                    <TableRow>
                                        <TableCell
                                            sx={{
                                                width: 130,
                                            }}
                                            className="font-bold text-white rounded-tl-lg"
                                        >
                                            Ngày đăng
                                        </TableCell>
                                        <TableCell
                                            className="font-bold text-white rounded-tr-lg"
                                        >
                                            <p>Tiêu đề</p>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {newsList.map((row) => (
                                        <TableRow
                                            onClick={() => {
                                                navigate(
                                                    `/utility/general-notifications/view/${row.id}`
                                                );
                                            }}
                                            sx={{
                                                "&:last-child td, &:last-child th":
                                                {
                                                    border: 0,
                                                },
                                            }}
                                        >
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                {moment(row?.created_date).format('DD/MM/YYYY')}
                                            </TableCell>
                                            <TableCell>
                                                <p>{row?.subject}</p>
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </section>
                </div>}

                <TablePagination
                    component="div"
                    count={tintucStore.tinTucTotalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Số bản ghi"
                />

            </div>
        </MainLayout>
    )
}
export default inject("tintucStore")(observer(TinTucPage));
